@import '../../../globals/main.scss';

pn-profile-modal-type {
  display: flex;
  width: 100%;
  padding: 3.2rem 0 1.2rem;
  flex-direction: column;
  gap: 1.6rem;
  &:first-of-type {
    margin-top: 2.4rem;
  }
  &:last-of-type {
    border-bottom: 0;
    padding-bottom: 0;
    .profileselectoroption {
      padding-bottom: 0;
    }
  }
  display: none;
  &[selected='true'] {
    display: flex;
    opacity: 1;
  }
}
